<template>
  <TransSlot>
    <form @submit="onSubmit">
      <InputSlot type="email" :func="getEmail">
        <input type="email" class="email" v-model="email" />
      </InputSlot>
      <InputSlot type="message" :func="getMessage">
        <textarea class="message height" v-model="message" />
      </InputSlot>
      <div class="flex">
        <Spinner v-if="getLoading" />
        <Button />
      </div>
      <div class="flex email-res">{{getEmailRes}}</div>
    </form>
  </TransSlot>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import InputSlot from "./InputSlot";
import Button from "./Button";
import Spinner from "./Spinner";
import TransSlot from "./TransSlot";

export default {
  name: "Form",
  components: {
    InputSlot,
    Button,
    Spinner,
    TransSlot,
  },
  data: () => ({
    email: "",
    message: "",
  }),
  methods: {
    ...mapActions(["emailAction"]),
    onSubmit(e) {
      e.preventDefault();
      const { emailAction, createObject, email, message } = this;
      emailAction(createObject(email, message));
      this.email = "";
      this.message = "";
    },
    createObject(x, y) {
      const object = {};
      object.email = x;
      object.message = y;
      return object;
    },
  },
  computed: {
    ...mapGetters(["getLoading", "getEmailRes"]),
    getEmail() {
      return this.email;
    },
    getMessage() {
      return this.message;
    },
  },
};
</script>

<style scoped>
form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
}

.flex {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 460px;
  height: 56px;
}

.email-res {
  color: var(--blue);
}

@media (max-width: 414px) {
  input,
  textarea,
  .flex {
    width: 378px;
  }
}
@media (max-width: 375px) {
  input,
  textarea,
  .flex {
    width: 343px;
  }
}
</style>
